'use strict';

const { h } = require('preact');

const RegularPrice = ({
  option: {
    isUrgencyPricing,
    pricing: { urgencyPricing },
    showDoubleStrikeThroughPrice,
  },
}) => {
  if (!showDoubleStrikeThroughPrice || !isUrgencyPricing) {
    return null;
  }

  return h(
    'div',
    {
      class: 'breakout-option-regular-price',
    },
    `${urgencyPricing.formattedOldPrice}`
  );
};

module.exports = RegularPrice;
